"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const helper_1 = require("../../../../../reviews/helper");
const selectors_1 = __importDefault(require("../../../../slice/selectors"));
const sliceReview_1 = require("../../../../slice/sliceReview");
const sliceTemplate_1 = require("../../../../slice/sliceTemplate");
const store_1 = require("../../../../store");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const ApplyTemplateModal = ({ executeScroll, open = false }) => {
    var _a, _b;
    const { selectedTemplate } = (0, react_redux_1.useSelector)(selectors_1.default);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const resetSelectTemplate = () => {
        dispatch((0, sliceTemplate_1.setSelectedTemplate)(null));
        dispatch((0, sliceTemplate_1.setOpenTemplateModal)(false));
    };
    const getStageByTemplate = async (action) => {
        utilities_1.default.blockPage();
        if (selectedTemplate) {
            const templateStages = await pulse_components_1.v2Endpoint
                .get(`${utilities_1.URLS.app}api/workflow-templates/${selectedTemplate.value}`)
                .then((res) => {
                const { data } = res;
                const currentTemplate = (0, utilities_1.camelizeKeys)((0, utilities_1.parseJsonApi)(data));
                const parsed = (0, helper_1.parseTemplateResponseStage)(currentTemplate.stages);
                utilities_1.default.notification.success('Template applied.');
                utilities_1.default.unblockPage();
                return parsed;
            })
                .catch((error) => {
                utilities_1.default.unblockPage();
                utilities_1.default.notification.danger(error);
            });
            if (templateStages) {
                dispatch((0, sliceReview_1.updateRoundStagesTemplate)({
                    stages: templateStages,
                    action,
                }));
                resetSelectTemplate();
            }
        }
    };
    const handleTemplate = async (action) => {
        await getStageByTemplate(action);
        if (executeScroll) {
            executeScroll();
        }
    };
    return (react_1.default.createElement("div", { "data-testid": "apply-template-modal" },
        react_1.default.createElement(pulse_components_1.PulseModalBase, { onConfirmClick: () => handleTemplate('replace'), onModalClose: () => {
                resetSelectTemplate();
            }, open: open, variant: "jqconfirm", headerPrimaryText: "APPLY TEMPLATE", headerIconClasses: "fal fa-exclamation-circle", footerConfirmText: "REPLACE REVIEW STAGES", footerCancelComponent: react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['apply-template-footer__cancelBtn']], color: pulse_components_1.Colors.default, iconClasses: { icon: 'fal fa-user' }, label: 'ADD TO REVIEW STAGES', onClick: () => handleTemplate('append'), variant: pulse_components_1.ButtonVariants.contained }), classes: {
                footer: {
                    root: [styles_modules_less_1.default['apply-template-footer']],
                },
            } },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['apply-template-body'] },
                react_1.default.createElement("p", null, "Selected workflow template:"),
                react_1.default.createElement("b", null, (_a = selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.label) !== null && _a !== void 0 ? _a : (_b = selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.raw) === null || _b === void 0 ? void 0 : _b.name),
                react_1.default.createElement("p", null, "Would you like to add the Template Stages and Reviewers to this Review or replace the current Review Stages and Reviewers with this Template?")))));
};
exports.default = ApplyTemplateModal;
